import { FC } from 'react';
import { Grid } from '@mui/material';
import AcademicsSchedulesGrid from './academicsSchedulesGrid.view';
import { useAcademicsSchedulesContext } from '../../contexts/academicsSchedules.context';
import AddEditScheduleView from './addEditSchedule.view';

const AcademicsSchedules: FC = () => {
  const {
    academicsSchedulesAppState: { isManageScheduleOpen },
  } = useAcademicsSchedulesContext();

  return (
    <Grid
      container
      spacing={{ xs: 1, sm: 2 }}
      sx={{ height: '100%', p: { xs: 1, sm: 2 } }}
      data-testid="academics-schedules-container"
    >
      <Grid item xs={12}>
        <AcademicsSchedulesGrid />
      </Grid>
      {isManageScheduleOpen && <AddEditScheduleView />}
    </Grid>
  );
};

export default AcademicsSchedules;
